import { useState, useEffect } from "react";

/**
 * window 幅で「モバイル幅かどうか」を判定する簡易フック。
 * デフォルト breakpoint = 768px（タブレット縦置きあたり）。
 *
 * 利用例:
 *   const isMobile = useIsMobile();
 *   <div style={{ padding: isMobile ? "8px 10px" : "20px 24px" }} />
 */
export default function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(() => {
    if (typeof window === "undefined") return false;
    return window.innerWidth < breakpoint;
  });

  useEffect(() => {
    if (typeof window === "undefined") return undefined;
    const onResize = () => setIsMobile(window.innerWidth < breakpoint);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [breakpoint]);

  return isMobile;
}
